import React, { useState } from "react"
// import { LogBuildingStyled, LogItemStyled } from "./wiczlinoStyle"
import { Col, Container, Row } from "react-bootstrap"
import { PhoneButton, EmailButton } from "../shared/button/button"
import FsLightbox from "fslightbox-react"
import { injectIntl } from "gatsby-plugin-intl"
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import styled from "styled-components"

const LogBuilding = ({logs, anchor, id= 'diary', title = null, intl }) => {

  return (
    <>
      <LogBuildingStyled className="diary" >
        <AnchorLink to={anchor} />
        <Container id={id}>
          <div className="heading">
            <h2>{ title || intl.formatMessage({id: "offer.janowo.diary.title"})}</h2>
          </div>
          {logs.map(item => (
            <LogBuildingItem key={item.title} item={item} intl={intl} />
          ))}
        </Container>
        <Container
          className="no-padding buttons-timeline"
          style={{ margin: "auto" }}
        >
          <Row>
            <Col className="offset-timeline" xs="0" md="3" lg="4" />
            <Col xs="12" md="6" lg="4" className="no-padding">
              <PhoneButton />
              <EmailButton />
            </Col>
            <Col xs="0" md="3" lg="4" />
          </Row>
        </Container>
      </LogBuildingStyled>
    </>
  )
}

const LogBuildingItem = ({ item, intl }) => {
  // const [toggler, setToggler] = useState(false)
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  });

  const [mobileImages, setMobileImages] = useState(3)
  const [desktopImages, setDesktopImages] = useState(6)

  function openLightboxOnSlide(number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number
    });
  }

  return (
    <LogItemStyled>
      <Container fluid className="no-padding">
        <Row>
          <Col xs="2" md="1" className="no-padding timeline-container">
            <div className={`${item.className || ''} timeline`} />
          </Col>
          <Col xs="10" md="11" className="no-padding">
            <Row>
              <Col xs={12} className={"month no-padding"}>
                <p>{intl.formatMessage({id: item.title})} {item.year || ''}</p>
              </Col>
              {item.pics.length > 1 && item.pics[0].map((pic, i) => (
                  <Col
                    key={i}
                    xs={6}
                    sm={6}
                    md={3}
                    lg={2}
                    className={"no-padding image--desktop"}
                  >
                    {i < desktopImages && (
                      <div className={"log-image"}>
                        <LazyLoadImage
                          alt={item.alts[i]}
                          src={item.pics[1][i]}
                          width={194}
                          height={100}
                          effect="blur"
                          onClick={() => {openLightboxOnSlide(i + 1)}}
                        />
                        {desktopImages === 6 && i === desktopImages - 1 && desktopImages < item.pics[0].length && (
                            <div className={`image--desktop`}>
                              <span
                                  className={`show-more--desktop`}
                                  onClick={() => {setDesktopImages(item.pics[0].length)}}
                              >
                                {intl.formatMessage({id: "general.more"})}
                              </span>
                            </div>
                        )}
                      </div>
                    )}
                  </Col>
              ))}

              {item.pics[0].map((pic, i) => (
                <Col
                  key={pic}
                  xs={12}
                  className={"no-padding image--mobile"}
                >
                  {i < mobileImages &&
                  <div className={"log-image"}>
                    <LazyLoadImage
                      alt={item.alts[i]}
                      src={item.pics[1][i]}
                      width={194}
                      height={100}
                      effect="blur"
                      onClick={() => {
                        openLightboxOnSlide(i + 1)
                      }}
                    />
                  </div>
                  }
                </Col>
              ))}
              {item.pics[0] && item.pics[0].length > mobileImages && (
                <div className={`image--mobile`}>
                  <span
                      className={`show-more`}
                      onClick={() => {setMobileImages(mobileImages + 3)}}
                  >
                    {intl.formatMessage({id: "general.more"})}
                  </span>
                </div>
              )}
              <FsLightbox
                toggler={lightboxController.toggler}
                sources={[...item.pics[0]]}
                slide={lightboxController.slide}
              />
            </Row>
          </Col>
        </Row>
      </Container>
    </LogItemStyled>
  )
}
export default injectIntl(LogBuilding)


export const LogBuildingStyled = styled.div`


  @media only screen and (min-width: 768px) {
    margin: 0 0 100px;

    & + & {
      margin-top: -100px;
    }
  }

  padding: 100px 0 45px;

  .no-padding {
    margin: 0;
    padding: 0;
  }

  button {
    width: 100%;
  }


  div:nth-child(2) {
    border: none !important;
  }

  .heading {
    padding-bottom: 30px;
    font-size: 20px;

    h2 {
      padding-bottom: 32px;
      font-size: 37px;
    }

    p {
      font-weight: 200;

      span {
        font-weight: 500;
      }
    }
  }

  .buttons-timeline {
    padding-top: 100px;
    max-width: 260px;

    button {
      margin: 0 0 10px;
    }

    @media only screen and (min-width: 768px) {
      display: none;
    }
  }
`


export const LogItemStyled = styled.div`
.timeline-container {
  position: relative;
}

  .first-item {
    display: none;
  }

  .timeline {
    width: 2px;
    height: 100%;
    background-color: #94c835;
    position: absolute;
    @media only screen and (max-width: 768px) {
      left: 20%;
    }
    left: 50%;
    top: 25px;
    transform: translateX(-50%);

    ::before {
      background-color: #94c835;
      content: "";
      position: absolute;
      left: 50%;
      top: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 4px solid white;
      transform: translate(-50%, -50%)
    }

    ::after {
      background-color: #94c835;
      content: "";
      position: absolute;
      left: 50%;
      bottom: -10px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 4px solid white;
      transform: translateX(-50%)
    }
  }

  .no-padding {
    margin: 0;
    padding: 0;
  }

  .month {
    padding: 0;
    font-size: 24px;

    p {
      margin: 0;
      font-weight: 500;
      padding: 10px 0;
      height: 50px;
      font-size: 20px;
    }
  }

  .log-image:nth-child(1) {
    margin-bottom: 8px;
    margin-right: 8px;
  }

  .log-image:nth-child(2) {
    margin-bottom: 8px;
    margin-left: 8px;
  }

  .log-image:nth-child(3) {
    margin-top: 8px;
    margin-right: 8px;
  }

  .log-image:nth-child(4) {
    margin-top: 8px;
    margin-left: 8px;
  }

  .log-image {
    padding: 0;
    overflow: hidden;
    height: 100px;
    background-color: #fafafa;
    position: relative;

    @media (min-width: 1440px) {
      width: 194px;
    }

    img {
      object-fit: cover;
      cursor: pointer;
      background-color: #fafafa;

      @media only screen and (max-width: 480px) {
        width: 100%;
      }
    }
  }

  .image--desktop {
    display: none;
    @media only screen and (min-width: 480px) {
      display: block;
    }
  }

  .image--mobile {
    display: none;
    @media only screen and (max-width: 480px) {
      display: block;
    }
  }

  .show-more {
    background-color: rgb(148, 200, 53);
    padding: 0.25em 1em;
    display: inline-block;
    color: #fff;
    border-radius: 3px;
  }

  .show-more--desktop {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(148, 200, 53, 0.75);
    font-size: 18px;
    font-weight: 500;
    padding: 0.25em 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }
`
